module.exports = __webpack_public_path__ + "0b3a96317034bc958db9c20e038e425f.pdf";